import React from 'react';
import './Cart.css';
import CartCheckOut from '../../Components/CartCheckOut/CartCheckOut';
import CartList from '../../Components/CartList/CartList';
import { useLocation } from 'react-router-dom';

function Cart() {
    const location = useLocation();
    const { classId } = location.state || {};

    return (
        <div className='cart-container'>
            <div className='cart-header'>
                <h1 className='cart-title'>Your Learning Cart</h1>
                <span className='cart-subtitle'>Review your selected classes before checkout</span>
            </div>
            <div className='cart-content'>
                <div className='cart-items-section'>
                    <CartList />
                </div>
                <div className='payment-section'>
                    <CartCheckOut />
                </div>
            </div>
        </div>
    );
}

export default Cart;